import { render, staticRenderFns } from "./Tenthousandtow.vue?vue&type=template&id=680b5a7a&"
import script from "./Tenthousandtow.vue?vue&type=script&lang=ts&"
export * from "./Tenthousandtow.vue?vue&type=script&lang=ts&"
import style0 from "./Tenthousandtow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports